// extracted by mini-css-extract-plugin
module.exports = {"ReferencesList":"ReferencesList_ReferencesList__3WenX"};